var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0216 22.9017C23.5166 22.9017 23.9175 23.3181 23.9175 23.8322C23.9175 24.3456 23.5166 24.7619 23.0216 24.7619L7.17959 24.7617C6.68509 24.7617 6.28418 24.3453 6.28418 23.832C6.28418 23.3179 6.68507 22.9015 7.17959 22.9015H23.0216V22.9017ZM7.13769 21.6466L9.28983 15.6779L12.7971 19.3207L7.13769 21.6466ZM13.5162 18.6345L9.97894 14.9617L19.5945 5.05547L23.1317 8.72801L13.5162 18.6345ZM23.7917 7.9651L20.2547 4.29237L22.0239 2.45601C22.6102 1.848 23.5593 1.848 24.1455 2.45601L25.5602 3.92494C26.1465 4.53364 26.1465 5.52073 25.5602 6.12944L23.7917 7.9651Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.6ccd31f4639ca79c0e4870d02b355a80.svg";
export { ForwardRef as ReactComponent };